import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, first, map, switchMap, tap } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { select, Store } from '@ngrx/store';
import * as fromRoot from 'app/core/store';
import * as fromAuth from 'app/auth/store';
import { CLINICIAN_MENU_ROLES } from 'app/core/services/navigation.service';

@Injectable({
  providedIn: 'root'
})
export class ClinicianGuard implements CanActivate {
  constructor(
    private router: Router,
    public snackbar: MatSnackBar,
    private store: Store<fromRoot.AppState>
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(fromAuth.getRolesLoaded),
      filter(loaded => loaded),
      switchMap(() => this.store.pipe(select(fromAuth.getUserRoles))),
      first(),
      map(roles => Array.isArray(roles) && roles.some(r => CLINICIAN_MENU_ROLES.includes(r))),
      tap(isClinician => {
        if (!isClinician) {
          this.router.navigate(['/dashboard']);
          this.snackbar.open(`Forbidden: You don't have access to this page.`, 'Dismiss', { duration: 3000 });
        }
      })
    );
  }
}
